import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import AccessoryCheckCreateUpdate, {
  AccessoryCheckCreateUpdateHandle,
  AccessoryCheckCreateUpdateProps,
} from "./AccessoryCheckCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: AccessoryCheckCreateUpdateProps;
}

export default function AccessoryCheckCreateUpdateModal({
  createUpdateProps,
  ...modalProps
}: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.accessoryCheckId });
  const formWrapperRef = useRef<AccessoryCheckCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} accessory check
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <AccessoryCheckCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
